import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IPortfolioTypesState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState = {
  isLoading: false,
};